/**
 * Що дозволено в малюнку до питання.
 *
 * Список — межа безпеки. Розмітка малюнків вставляється в документ як HTML,
 * і це єдине місце, де її взагалі можна зупинити: жодного `script`, жодних
 * обробників подій, посилань і `style`. Джерело зараз своє (наш код на
 * сервері), але банк питань поповнює ще й LLM-пайплайн.
 *
 * Живе у спільному пакеті НАВМИСНО, хоч застосовує його лише клієнт. Список
 * має рівно двох читачів, і вони мусять бачити одне й те саме:
 *   — `apps/web/src/components/SafeSvg.tsx` за ним ріже розмітку;
 *   — тест рушія за ним перевіряє, що генератори не малюють нічого зайвого.
 * Поки список був лише в клієнті, розійтися вони могли мовчки: генератор
 * додає тег, `SafeSvg` його зрізає, і дитина бачить наполовину порожній
 * малюнок — без жодної помилки бодай десь.
 *
 * Розширювати список — свідома дія. Спершу переконайся, що новий тег чи
 * атрибут не вміє тягнути зовнішні дані й не виконує коду.
 */

export const ALLOWED_SVG_TAGS: ReadonlySet<string> = new Set([
  'svg',
  'g',
  'path',
  'rect',
  'circle',
  'ellipse',
  'line',
  'polygon',
  'polyline',
  'text',
  'tspan',
  'defs',
  'lineargradient',
  'stop',
  'title',
]);

export const ALLOWED_SVG_ATTRS: ReadonlySet<string> = new Set([
  'viewbox',
  'width',
  'height',
  'fill',
  'stroke',
  'stroke-width',
  'stroke-linejoin',
  'stroke-linecap',
  'stroke-dasharray',
  'opacity',
  'fill-opacity',
  'stroke-opacity',
  'transform',
  'points',
  'd',
  'cx',
  'cy',
  'r',
  'rx',
  'ry',
  'x',
  'y',
  'x1',
  'y1',
  'x2',
  'y2',
  'dx',
  'dy',
  'font-size',
  'font-weight',
  'font-family',
  'text-anchor',
  'dominant-baseline',
  'offset',
  'stop-color',
  'stop-opacity',
  'gradientunits',
  'id',
]);

/**
 * Службові атрибути кореня: до малювання не мають стосунку, тому в загальному
 * списку їм не місце, але й зрізати їх не треба.
 */
export const ROOT_SVG_ATTRS: ReadonlySet<string> = new Set(['xmlns', 'preserveaspectratio']);

/**
 * Зрізається свідомо. Генератори ставлять на `<svg>` `role="img"`, але
 * обгортка в `SafeSvg` уже несе `role="img"` і `aria-label` — вкладені
 * однакові ролі екранному читачеві лише заважають.
 */
export const KNOWINGLY_DROPPED_SVG_ATTRS: ReadonlySet<string> = new Set(['role']);

/** Теги, які лишають на екрані видимий слід. Малюнок без жодного — порожній. */
export const DRAWABLE_SVG_TAGS: ReadonlySet<string> = new Set([
  'path',
  'rect',
  'circle',
  'ellipse',
  'line',
  'polygon',
  'polyline',
  'text',
]);
